package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_add_button
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit1_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit1_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit2_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit2_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit3_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_benefit3_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_claim_button
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_claim_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_claim_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_claim_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_draft_desc
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_draft_discard
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_draft_resume
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_draft_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_hero_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_hero_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_hero_title
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_learn_more
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources.ab_intro_top_title
import org.jetbrains.compose.resources.stringResource

/**
 * Add / Claim intro — Stitch `1225e1f7`. Sells the value of listing, offers a "claim an existing
 * listing" search, and starts a new listing. Tokens + string resources only; stateless (claim query
 * is local). The host wires [onAddBusiness] (→ Step 1) and [onSearchRegistry] (claim = the directory
 * search for now; the full claim flow is Phase 2).
 */
@Composable
fun AddBusinessIntroScreen(
    onBack: () -> Unit,
    onAddBusiness: () -> Unit,
    onSearchRegistry: (query: String) -> Unit,
    onLearnMore: () -> Unit,
    modifier: Modifier = Modifier,
    hasSavedDraft: Boolean = false,
    onResumeDraft: () -> Unit = {},
    onDiscardDraft: () -> Unit = {},
) {
    var claimQuery by remember { mutableStateOf("") }

    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidthCompact)) {
        // Teal top bar
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.primaryContainer)
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.ab_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onPrimary,
            )
            Text(
                text = stringResource(Res.string.ab_intro_top_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onPrimary,
            )
        }

        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
                .navigationBarsPadding()
                .padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            // Resume a saved draft (auto-saved as the owner types; restored across restarts).
            if (hasSavedDraft) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.card)
                        .padding(AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        AppIcon(name = "history_edu", tint = AppTheme.colors.onSecondaryContainer)
                        Text(
                            text = stringResource(Res.string.ab_intro_draft_title),
                            style = AppTheme.typography.headlineMd,
                            color = AppTheme.colors.onSecondaryContainer,
                        )
                    }
                    Text(
                        text = stringResource(Res.string.ab_intro_draft_desc),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSecondaryContainer,
                    )
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        AppButton(
                            text = stringResource(Res.string.ab_intro_draft_resume),
                            onClick = onResumeDraft,
                            modifier = Modifier.weight(1f),
                            trailingIcon = "arrow_forward",
                        )
                        AppButton(
                            text = stringResource(Res.string.ab_intro_draft_discard),
                            onClick = onDiscardDraft,
                            modifier = Modifier.weight(1f),
                            variant = AppButtonVariant.Secondary,
                        )
                    }
                }
            }

            // Hero
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .aspectRatio(16f / 9f)
                    .background(AppTheme.colors.primaryContainer, AppTheme.shapes.card),
                contentAlignment = Alignment.Center,
            ) {
                AppIcon(
                    name = "handshake",
                    size = AppTheme.sizes.iconHero,
                    tint = AppTheme.colors.onPrimary,
                    contentDescription = stringResource(Res.string.ab_intro_hero_a11y),
                )
            }

            Text(
                text = stringResource(Res.string.ab_intro_hero_title),
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.ab_intro_hero_subtitle),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )

            Benefit("groups", stringResource(Res.string.ab_intro_benefit1_title), stringResource(Res.string.ab_intro_benefit1_desc))
            Benefit("reviews", stringResource(Res.string.ab_intro_benefit2_title), stringResource(Res.string.ab_intro_benefit2_desc))
            Benefit("verified", stringResource(Res.string.ab_intro_benefit3_title), stringResource(Res.string.ab_intro_benefit3_desc))

            // Claim existing
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surface, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = stringResource(Res.string.ab_intro_claim_title),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.ab_intro_claim_desc),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                AppTextField(
                    value = claimQuery,
                    onValueChange = { claimQuery = it },
                    placeholder = stringResource(Res.string.ab_intro_claim_placeholder),
                    leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
                )
                AppButton(
                    text = stringResource(Res.string.ab_intro_claim_button),
                    onClick = { onSearchRegistry(claimQuery) },
                    modifier = Modifier.fillMaxWidth(),
                    variant = AppButtonVariant.Secondary,
                )
            }

            AppButton(
                text = stringResource(Res.string.ab_intro_add_button),
                onClick = onAddBusiness,
                modifier = Modifier.fillMaxWidth(),
                trailingIcon = "arrow_forward",
            )
            Text(
                text = stringResource(Res.string.ab_intro_learn_more),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.primary,
                textAlign = TextAlign.Center,
                modifier = Modifier.fillMaxWidth().clickable(onClick = onLearnMore),
            )
        }
    }
}

@Composable
private fun Benefit(icon: String, title: String, description: String) {
    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.avatarMd)
                .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.tile),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(name = icon, tint = AppTheme.colors.onSecondaryContainer)
        }
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
            Text(text = title, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurface)
            Text(text = description, style = AppTheme.typography.bodySm, color = AppTheme.colors.onSurfaceVariant)
        }
    }
}
